module.exports = __webpack_public_path__ + "static/img/passport-sample.db9f19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/upload/passport-sample.png
// module id = 3d5z
// module chunks = 4